import { ALL_CAPABILITY_KEYS, CapabilityKey } from '../util/capabilities';

/**
 * Key validation for the gating attributes.
 *
 * Separate from `capability-gating-directive.ts` and deliberately FREE OF
 * ANGULAR. The specs run under jasmine-ts in Node with no DOM, so a module that
 * reaches `../app` drags in angular.js, which touches `window` at import time
 * and takes the whole suite down with it.
 */

/**
 * Is `key` one of the keys the catalogue defines?
 *
 * The failure this guards is silent: an unknown key resolves to `notEntitled`,
 * indistinguishable from a capability legitimately switched off. A typo at a
 * call site therefore DELETES the control and reads as a working gate.
 */
export function isKnownCapabilityKey(key: string): key is CapabilityKey {
    return (ALL_CAPABILITY_KEYS as readonly string[]).indexOf(key) !== -1;
}
